import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Box, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { db } from '../../firebase';
import NewDeviceFields from '../../modules/devices/components/NewDeviceFields';
import { useDeviceBrands } from '../../modules/devices/hooks/useDeviceBrands';
import { collection, query, where, getDocs } from 'firebase/firestore';

const CustomerFormModal = ({ isOpen, onClose, onAddCustomer, onUpdateCustomer, customerToEdit }) => {
    const [adSoyad, setAdSoyad] = useState('');
    const [tcKimlikNo, setTcKimlikNo] = useState('');
    const [telefon, setTelefon] = useState('');
    const [email, setEmail] = useState('');
    const [adres, setAdres] = useState('');
    const [hizmetTuru, setHizmetTuru] = useState([]);
    const [smsIzin, setSmsIzin] = useState(true);

    // Cihaz alanları (NewDeviceFields için)
    const [addDevice, setAddDevice] = useState(false);
    const [seriNumarasi, setSeriNumarasi] = useState('');
    const [marka, setMarka] = useState('');
    const [model, setModel] = useState('');
    const [cihazSinifi, setCihazSinifi] = useState('Oksijen Konsantratörü');
    const [isSgk, setIsSgk] = useState(false);
    const [zimmetTarihi, setZimmetTarihi] = useState('');
    const [faturaNo, setFaturaNo] = useState('');
    const [verilisTarihi, setVerilisTarihi] = useState('');
    const [garantiBaslangic, setGarantiBaslangic] = useState('');
    const [garantiBitis, setGarantiBitis] = useState('');
    const [periyodikBakimTarihi, setPeriyodikBakimTarihi] = useState('');
    // Ekstra tarih alanları (NewDeviceFields içinde yok, burada tutulabilir veya oraya taşınabilir ama şimdilik burada kalsın)
    // NOT: NewDeviceFields şu an sadece SeriNo, Marka, Model yönetiyor. Tarihleri modal içinde tutuyoruz.
    // Ancak NewDeviceFields bileşenini zenginleştirmek gerekebilir. Şimdilik bu modalda ayrıca render edeceğiz.

    // Tarihler (Eski kodda DatePicker kullanıyordu, burada da aynen devam)
    // DIKKAT: DatePicker importunu düzelttik
    // Ancak orijinal kodda DatePicker kullanımı @mui/x-date-pickers'dan geliyordu.
    // NewDeviceFields içinde tarih yok. Bu yüzden tarih seçimlerini modalda manuel ekleyeceğiz.

    // Hook'tan markaları çek
    const { brandsFromDb } = useDeviceBrands();

    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen && customerToEdit) {
            setAdSoyad(customerToEdit.adSoyad);
            setTcKimlikNo(customerToEdit.tcKimlikNo || '');
            setTelefon(customerToEdit.telefon);
            setEmail(customerToEdit.email || '');
            setAdres(customerToEdit.adres || '');
            setHizmetTuru(customerToEdit.hizmetTuru ? (Array.isArray(customerToEdit.hizmetTuru) ? customerToEdit.hizmetTuru : [customerToEdit.hizmetTuru]) : []);
            setSmsIzin(customerToEdit.smsIzin !== false);
            setAddDevice(false);
        } else {
            setAdSoyad(''); setTcKimlikNo(''); setTelefon(''); setEmail(''); setAdres('');
            setHizmetTuru([]);
            setSmsIzin(true);

            setAddDevice(false);
            setSeriNumarasi(''); setMarka(''); setModel(''); setCihazSinifi('Oksijen Konsantratörü');
            setIsSgk(false); setZimmetTarihi('');
            setFaturaNo(''); setVerilisTarihi(''); setGarantiBaslangic(''); setGarantiBitis(''); setPeriyodikBakimTarihi('');
            // Tarihleri null yap
        }
    }, [customerToEdit, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!adSoyad || !telefon) {
            alert('Ad Soyad ve Telefon alanları zorunludur.');
            return;
        }
        if (addDevice && (!seriNumarasi || !marka)) {
            alert('Cihaz eklemek için Seri Numarası ve Marka alanları zorunludur.');
            return;
        }

        // Normalizasyon yardımcı fonksiyonu (formatları standardize etmek için)
        const normalizePhone = (phone) => {
            if (!phone) return '';
            let num = phone.toString().replace(/\D/g, ''); // Harf ve özel karakterleri at, sadece rakam bırak
            if (num.startsWith('90') && num.length > 10) num = num.substring(2); // Başında 90 varsa at
            if (num.startsWith('0')) num = num.substring(1); // Başında 0 varsa at
            return num; // Geriye saf 10 haneli (veya benzeri) numara kalır (örn: 5321234567)
        };

        // Telefon Kontrolü (Mükerrer Kayıt Önleme)
        try {
            const normalizedInputPhone = normalizePhone(telefon);
            
            // Eğer düzenleme modundaysak ve telefon kendi numaramızsa atla
            const isEditingAndSamePhone = customerToEdit && normalizePhone(customerToEdit.telefon) === normalizedInputPhone;
            
            if (!isEditingAndSamePhone && normalizedInputPhone.length >= 10) {
                // Normalize edilmiş telefon `telefonNormalized` alanında saklanır ve
                // sunucu tarafındaki onCustomerNormalize trigger'ı tarafından güncel
                // tutulur (bkz. functions/triggers/normalizeTriggers.js). Eskiden bu
                // kontrol TÜM müşterileri okuyordu (1324 doküman / her kayıt); artık
                // tek hedefli sorgu (~1 okuma) ve canlı veriye bakıldığı için koruma
                // da zayıflamıyor.
                const querySnapshot = await getDocs(
                    query(collection(db, "customers"), where("telefonNormalized", "==", normalizedInputPhone))
                );
                let foundDuplicate = null;

                querySnapshot.forEach(docSnap => {
                    if (customerToEdit && docSnap.id === customerToEdit.id) return; // kendi kaydı
                    foundDuplicate = docSnap.data();
                });

                if (foundDuplicate) {
                    alert(`⚠️ Bu telefon numarası zaten kayıtlı!\n\nGirilen numara: ${telefon}\nMevcut müşteri: ${foundDuplicate.adSoyad}\n\nAynı telefon numarası ile ikinci bir müşteri kaydedilemez.`);
                    return;
                }
            }
        } catch (error) {
            console.error("Telefon duplicate kontrol hatası:", error);
            alert("Telefon numarası kontrolü yapılırken bir hata oluştu. Lütfen tekrar deneyin.");
            return;
        }

        // TC Kimlik Kontrolü (Mükerrer Kayıt Önleme)
        if (tcKimlikNo) {
            try {
                // Eğer düzenleme modundaysak ve TC değişmemişse kontrol etme
                if (customerToEdit && customerToEdit.tcKimlikNo === tcKimlikNo) {
                    // Değişiklik yok, devam et
                } else {
                    const q = query(collection(db, "customers"), where("tcKimlikNo", "==", tcKimlikNo));
                    const querySnapshot = await getDocs(q);
                    if (!querySnapshot.empty) {
                        alert(`Bu TC Kimlik Numarası (${tcKimlikNo}) ile kayıtlı başka bir müşteri bulunmaktadır!`);
                        return;
                    }
                }
            } catch (error) {
                console.error("TC kontrol hatası:", error);
                alert("TC kontrolü yapılırken bir hata oluştu.");
                return;
            }
        }

        setIsSaving(true);
        const customerData = { adSoyad, tcKimlikNo, telefon, email, adres, hizmetTuru, smsIzin };
        const deviceInfo = {
            seriNumarasi,
            marka,
            model,
            cihazSinifi,
            isSgk,
            zimmetTarihi,
            faturaNo,
            verilisTarihi,
            garantiBaslangic,
            garantiBitis,
            periyodikBakimTarihi,
            // Tarihler şimdilik state'de yok, eğer gerekirse eklenmeli.
            // Orijinal kodda verilisTarihi vs vardı, ama NewDeviceFields entegrasyonunda bunları dışarıda tuttuk.
            // ÖNEMLİ: Hızlı cihaz eklemede genellikle sadece temel bilgiler istenir.
            // Detaylı tarih girişi gerekirse buraya DatePicker eklenmeli.
            // Kullanıcının talebi "Fix quick device add" -> Autocomplete çalışmıyordu.
            // Tarihleri şimdilik opsiyonel bırakıyoruz veya kaldırdık çünkü NewDeviceFields sadece temel info.
            // Eğer kullanıcı tarih isterse ekleriz.
        };

        try {
            if (customerToEdit) {
                await onUpdateCustomer(customerToEdit.id, customerData);
            } else {
                await onAddCustomer(customerData, addDevice ? deviceInfo : null);
            }
            onClose();
        } catch (error) {
            console.error("Müşteri/Cihaz kaydedilirken hata:", error);
            alert("Bir hata oluştu.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!isOpen) return null;
    const isEditing = !!customerToEdit;

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{isEditing ? 'Müşteri Bilgilerini Düzenle' : 'Yeni Müşteri Ekle'}</DialogTitle>
            <DialogContent>
                <Box component="form" noValidate autoComplete="off" sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField label="Adı Soyadı" value={adSoyad} onChange={(e) => setAdSoyad(e.target.value)} fullWidth required />
                    <TextField label="TC Kimlik No" value={tcKimlikNo} onChange={(e) => setTcKimlikNo(e.target.value)} fullWidth />
                    <TextField label="Telefon Numarası" value={telefon} onChange={(e) => setTelefon(e.target.value)} fullWidth required />
                    <TextField label="E-posta Adresi" type="email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth />
                    <TextField label="Adres" value={adres} onChange={(e) => setAdres(e.target.value)} multiline rows={3} fullWidth />
                    <FormControl fullWidth>
                        <InputLabel>Hizmet Türü</InputLabel>
                        <Select
                            multiple
                            value={Array.isArray(hizmetTuru) ? hizmetTuru : (hizmetTuru ? [hizmetTuru] : [])}
                            label="Hizmet Türü"
                            onChange={(e) => {
                                const { target: { value } } = e;
                                setHizmetTuru(typeof value === 'string' ? value.split(',') : value);
                            }}
                            renderValue={(selected) => selected.join(', ')}
                        >
                            <MenuItem value="Uyku Hastası">Uyku Hastası</MenuItem>
                            <MenuItem value="Cihaz Sahibi">Cihaz Sahibi</MenuItem>
                            <MenuItem value="Cihaz Satışı">Cihaz Satışı</MenuItem>
                            <MenuItem value="Kiralama">Kiralama</MenuItem>
                            <MenuItem value="Diğer">Diğer</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControlLabel control={<Checkbox checked={smsIzin} onChange={(e) => setSmsIzin(e.target.checked)} />} label="SMS Bildirimlerini Almak İstiyor" />

                    {!isEditing && (
                        <NewDeviceFields
                            addDevice={addDevice}
                            setAddDevice={setAddDevice}
                            seriNumarasi={seriNumarasi}
                            setSeriNumarasi={setSeriNumarasi}
                            marka={marka}
                            setMarka={setMarka}
                            model={model}
                            setModel={setModel}
                            cihazSinifi={cihazSinifi}
                            setCihazSinifi={setCihazSinifi}
                            isSgk={isSgk}
                            setIsSgk={setIsSgk}
                            zimmetTarihi={zimmetTarihi}
                            setZimmetTarihi={setZimmetTarihi}
                            brandsFromDb={brandsFromDb}
                            faturaNo={faturaNo} setFaturaNo={setFaturaNo}
                            verilisTarihi={verilisTarihi} setVerilisTarihi={setVerilisTarihi}
                            garantiBaslangic={garantiBaslangic} setGarantiBaslangic={setGarantiBaslangic}
                            garantiBitis={garantiBitis} setGarantiBitis={setGarantiBitis}
                            periyodikBakimTarihi={periyodikBakimTarihi} setPeriyodikBakimTarihi={setPeriyodikBakimTarihi}
                        />
                    )}
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: '16px 24px' }}>
                <Button onClick={onClose} disabled={isSaving}>İptal</Button>
                <Button onClick={handleSubmit} variant="contained" disabled={isSaving}>
                    {isSaving ? <CircularProgress size={24} /> : (isEditing ? 'Bilgileri Güncelle' : 'Kaydet')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CustomerFormModal;
